import React, { useEffect, useState, useRef } from 'react';
import { toast } from 'react-toastify';
import Button from '../components/buttons/Button';
import Table from '../components/tables/Table';
import Pagination from '../components/tables/pagination/Pagination';
import CustomLoading from '../components/customLoading/CustomLoading';
import SearchBar from '../components/searchBar/SearchBar';
import { BiFilterAlt, BiRefresh } from 'react-icons/bi';
import ShowModal from '../utils/ShowModal';
import { formatDateMonth } from '../utils/FormatDateTime';
import Dropdown from '../components/inputFields/DropDown';
import Breadcrumbs from '../components/BreadCrumbs';
import { addLead, assignTelecallingLeads, getLeadsAdmin, updateLead, uploadLeads } from '../services/telecalling';
import { getUserId } from '../helpers/local_storage_helpers';
import AddLeadForm from './AddLeadForm';
import TelecallingViewDetails from './TelecallingViewDetails';
import DateRangePicker from '../components/inputFields/DateRangePicker';
import { FiDownload, FiUpload } from 'react-icons/fi';
import { MdAdd } from 'react-icons/md';
import { downloadLeadsUrlApi } from '../constants/apis';
import { searchStaffUsers } from '../services/search';
import { statesOfIndia } from '../constants/states';

function Leads() {
    const [selectedLeads, setSelectedLeads] = useState([]);
    const [selectedUser, setSelectedUser] = useState(null);
    const [searchText, setSearchText] = useState("");
    const [dateRange, setDateRange] = useState({ start: null, end: null });
    const [statusFilter, setStatusFilter] = useState("");
    const [sourceFilter, setSourceFilter] = useState("");
    const [categoryFilter, setCategoryFilter] = useState("");
    const [addedByFilter, setStaffFilter] = useState("");
    const [assignedToFilter, setAssignedToFilter] = useState("");
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [modalIsOpen, setIsOpen] = useState(false);
    const [selectedLead, setSelectedLead] = useState(null);
    const [showAddLeadModal, setShowAddLeadModal] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [openindItem, setOpeningItem] = useState(null);
    const [staffUsers, setStaffUsers] = useState([]);
    const [stateFilter, setStateFilter] = useState("");
    const fileInputRef = useRef(null);
    const pageSize = 100;

    const headers = [
        { label: "Select", key: "checkbox" },
        { label: "Date", key: "created_at" },
        { label: "Category", key: "category" },
        { label: "Source", key: "lead_source" },
        { label: "Name", key: "farmer_name" },
        { label: "Contact", key: "phone" },
        { label: "Shop/Product", key: "shop_product" },
        { label: "Address", key: "address" },
        { label: "Added By", key: "added_by" },
        { label: "Assigned To", key: "assigned_to" },
        { label: "No. of Followups", key: "no_of_followups" },
        { label: "Status", key: "status" },
        { label: "Note", key: "note" },
    ];

    const statusOptions = [
        { value: "", label: "All Status" },
        { value: "pending", label: "Pending" },
        { value: "contacted", label: "Contacted" },
        { value: "interested", label: "Interested" },
        { value: "converted", label: "Converted" },
        { value: "not_interested", label: "Not Interested" },
        { value: "failed", label: "Failed" },
    ];

    const sourceOptions = [
        { value: "", label: "All Sources" },
        { value: "exhibition", label: "Exhibition" },
        { value: "google_ads", label: "Google Ads" },
        { value: "meta_ads", label: "Meta Ads" },
        { value: "website", label: "Website" },
        { value: "referral", label: "Referral" },
        { value: "social_media", label: "Social Media" },
        { value: 'on_ground', label: 'On Ground' },
        { value: "other", label: "Other" },
    ];

    const categoryOptions = [
        { value: "", label: "All Categories" },
        { value: "product", label: "Product Inquiry" },
        { value: "retailer", label: "Retailer" },
        { value: "fpo", label: "FPO" },
        { value: "satellite", label: "Satellite" },
        { value: "other", label: "Other" },
    ];

    useEffect(() => {
        fetchData(`&page_size=${pageSize}`);
    }, []);

    useEffect(() => {
        fetchStaff();
    }, []);

    const fetchData = async (query = "") => {
        setLoading(true);
        try {
            let res = await getLeadsAdmin(query);
            if (res.status === 200) {
                setData(res.data);
            } else {
                toast.error("Unable to fetch leads data");
            }
        } catch (error) {
            console.error("Error fetching leads:", error);
            toast.error("Error fetching leads data.");
        } finally {
            setLoading(false);
        }
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleSearch = (query) => {
        setSearchText(query);
        fetchData(`&search=${query}&status=${statusFilter}&lead_source=${sourceFilter}&category=${categoryFilter}&added_by=${addedByFilter}&assigned_to=${assignedToFilter}&start_date=${dateRange.start || ""}&end_date=${dateRange.end || ""}&page_size=${pageSize}&state=${stateFilter}`)
    };

    const handleStatusFilterChange = (value) => {
        setStatusFilter(value);
        fetchData(`&search=${searchText}&status=${value}&lead_source=${sourceFilter}&category=${categoryFilter}&added_by=${addedByFilter}&assigned_to=${assignedToFilter}&start_date=${dateRange.start || ""}&end_date=${dateRange.end || ""}&page_size=${pageSize}&state=${stateFilter}`);
    };

    const handleSourceFilterChange = (value) => {
        setSourceFilter(value);
        fetchData(`&search=${searchText}&status=${statusFilter}&lead_source=${value}&category=${categoryFilter}&added_by=${addedByFilter}&assigned_to=${assignedToFilter}&start_date=${dateRange.start || ""}&end_date=${dateRange.end || ""}&page_size=${pageSize}&state=${stateFilter}`);
    };

    const handleCategoryFilterChange = (value) => {
        setCategoryFilter(value);
        fetchData(`&search=${searchText}&status=${statusFilter}&lead_source=${sourceFilter}&category=${value}&added_by=${addedByFilter}&assigned_to=${assignedToFilter}&start_date=${dateRange.start || ""}&end_date=${dateRange.end || ""}&page_size=${pageSize}&state=${stateFilter}`);
    };

    const handleAddedByFilterChange = (value) => {
        setStaffFilter(value);
        fetchData(`&search=${searchText}&status=${statusFilter}&lead_source=${sourceFilter}&category=${categoryFilter}&added_by=${value}&assigned_to=${assignedToFilter}&start_date=${dateRange.start || ""}&end_date=${dateRange.end || ""}&page_size=${pageSize}&state=${stateFilter}`);
    };

    const handleAssignedToFilterChange = (value) => {
        setAssignedToFilter(value);
        fetchData(`&search=${searchText}&status=${statusFilter}&lead_source=${sourceFilter}&category=${categoryFilter}&added_by=${addedByFilter}&assigned_to=${value}&start_date=${dateRange.start || ""}&end_date=${dateRange.end || ""}&page_size=${pageSize}&state=${stateFilter}`);
    };

    const handleStateFilterChange = (value) => {
        setStateFilter(value);
        fetchData(`&search=${searchText}&status=${statusFilter}&lead_source=${sourceFilter}&category=${categoryFilter}&added_by=${addedByFilter}&assigned_to=${assignedToFilter}&start_date=${dateRange.start || ""}&end_date=${dateRange.end || ""}&page_size=${pageSize}&state=${value}`);
    };

    const handleDateRangeChange = (range) => {
        setDateRange(range);
        fetchData(`&search=${searchText}&status=${statusFilter}&lead_source=${sourceFilter}&category=${categoryFilter}&added_by=${addedByFilter}&assigned_to=${assignedToFilter}&start_date=${range.start}&end_date=${range.end}&page_size=${pageSize}&state=${stateFilter}`);
    };

    const fetchStaff = async () => {
        try {
            let res = await searchStaffUsers({ query: "?admin=true" });
            if (res.status === 200) {
                setStaffUsers(res.data);
            } else {
                toast.error("Unable to fetch leads stats");
            }
        } catch (error) {
            console.error("Error fetching lead stats:", error);
            toast.error("Error fetching leads stats.");
        }
    };

    useEffect(() => {
        const timeout = setTimeout(() => {
            fetchData(`&search=${searchText}&status=${statusFilter}&lead_source=${sourceFilter}&category=${categoryFilter}&added_by=${addedByFilter}&assigned_to=${assignedToFilter}&start_date=${dateRange.start || ""}&end_date=${dateRange.end || ""}&page_size=${pageSize}&page=${currentPage}&state=${stateFilter}`);
        }, 300);

        return () => clearTimeout(timeout);
    }, []);

    const resetFilters = () => {
        setSearchText("");
        setStatusFilter("");
        setSourceFilter("");
        setCategoryFilter("");
        setStaffFilter("");
        setAssignedToFilter("");
        setDateRange({ start: null, end: null });
        setStateFilter("");
        fetchData("");
    };

    const handleFileChange = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        if (!file.name.endsWith(".csv")) {
            toast.error("Please select a valid CSV file (.csv)");
            return;
        }

        const formData = new FormData();
        formData.append("file", file);

        try {
            let res = await uploadLeads(formData);
            if (res.status === 200) {
                toast.success("Leads imported successfully!");
                fetchData();
            } else if (res.status === "429") {
                toast.error(res.data.detail);
            } else {
                toast.error("Failed to import leads.");
            }
        } catch (error) {
            console.error("Upload error:", error);
            toast.error("Error importing leads.");
        }
    };

    const openLeadDetails = (lead) => {
        setSelectedLead(lead);
        setIsOpen(true);
    };

    const closeModal = () => {
        setIsOpen(false);
        setSelectedLead(null);
    };

    const toggleLeadSelection = (id) => {
        setSelectedLeads(prev => prev.includes(id) ? prev.filter(lid => lid !== id) : [...prev, id]);
    };

    const [isSelected, setIsSelected] = useState(false);

    const toggleSelectAll = () => {
        if (selectedLeads.length === data.results.length && data.results.length > 0) {
            setSelectedLeads([]);
        } else {
            setSelectedLeads(data.results.map(item => item.id));
        }
    };

    // Keep isSelected in sync with selectedLeads and data.results
    useEffect(() => {
        if (data?.results?.length > 0 && selectedLeads.length === data.results.length) {
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [selectedLeads, data.results]);

    const handleAssignLeads = async () => {
        try {
            let res = await assignTelecallingLeads({
                assigned_by: getUserId(),
                assigned_to: selectedUser,
                lead: selectedLeads,
            });
            if (res.status === 200) {
                toast.success("Leads assigned successfully!");
                setSelectedLeads([]);
                setSelectedUser(null);
            } else {
                toast.error("Unable to fetch leads data");
            }
        } catch (error) {
            console.error("Error fetching leads:", error);
            toast.error("Error fetching leads data.");
        }
    };

    const handleStatusChange = async (leadId, newStatus) => {
        try {
            let res = await updateLead(leadId, newStatus);
            if (res.status === 200) {
                toast.success("Lead status updated");
                fetchData();
            } else {
                toast.error("Failed to update lead status");
            }
        } catch (error) {
            console.error("Error updating lead status:", error);
            toast.error("Error updating lead status");
        }
    };

    const handleAddLeadSubmit = async (values) => {
        const transformedValues = {
            ...values,
            products: values.products.map(p => p.value),
        };

        setIsSubmitting(true);
        try {
            const response = openindItem ? await updateLead(openindItem.id, transformedValues) : await addLead({ ...transformedValues, added_by: getUserId() });

            if (response?.status === 201 || response?.status === 200) {
                fetchData();
                toast.success(openindItem ? "Lead updated successfully" : "Lead Added successfully!");
                setOpeningItem(null);
                setShowAddLeadModal(false);
            } else {
                let errors = "Opps! Something went wrong, please try again.";
                toast.error(errors);
            }
        } catch (error) {
            let errors =
                error?.response?.data?.error ||
                "Opps! Something went wrong, please try again.";
            toast.error(errors);
        }
        setIsSubmitting(false);
    };

    const handleUploadClick = () => {
        fileInputRef.current.click();
    };

    return (
        <div className="space-y-6">
            {/* Header Section */}
            <div className="bg-gradient-to-r from-green-50 to-emerald-50 rounded-xl p-6 border border-green-100">
                <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                    <div>
                        <Breadcrumbs items={[{ name: 'Home', link: '/dashboard' }, { name: 'Leads' }]} />
                        <h1 className="text-2xl font-bold text-gray-800 mt-2">Lead Management</h1>
                        <p className="text-gray-600 mt-1">Comprehensive lead tracking and management system</p>
                    </div>

                    <div className="flex items-center gap-3">
                        <Button
                            variant="outline"
                            onClick={() => window.open(downloadLeadsUrlApi, '_blank')}
                            className="text-sm px-4 py-2.5 rounded-lg border-2 flex flex-row border-primary items-center text-primary hover:bg-primary hover:text-white transition-all duration-200 shadow-sm hover:shadow-md"
                        >
                            <FiDownload size={16} className="mr-2" />
                            Download Template
                        </Button>

                        <Button
                            variant="outline"
                            onClick={handleUploadClick}
                            className="px-4 py-2.5 rounded-lg border-2 border-primary flex flex-row items-center text-primary hover:bg-primary hover:text-white transition-all duration-200 shadow-sm hover:shadow-md"
                        >
                            <FiUpload size={16} className="mr-2" />
                            Import
                        </Button>
                        <input
                            type="file"
                            ref={fileInputRef}
                            accept=".csv"
                            style={{ display: "none" }}
                            onChange={handleFileChange}
                        />

                        <Button
                            variant="primary"
                            onClick={() => setShowAddLeadModal(true)}
                            icon={<MdAdd size={18} />}
                            className="bg-primary hover:bg-primary-dark text-white px-6 py-2.5 rounded-lg shadow-lg hover:shadow-xl transition-all duration-200 transform hover:scale-105"
                        >
                            Add Lead
                        </Button>
                    </div>
                </div>
            </div>

            {/* Enhanced Filters Section */}
            <div className="bg-gradient-to-br from-green-50 to-emerald-50 border border-green-200 rounded-xl shadow-sm p-6">
                {/* Professional Header */}
                <div className="flex items-center justify-between mb-6">
                    <div className="flex items-center gap-3">
                        <div className="w-10 h-10 bg-green-500 rounded-lg flex items-center justify-center">
                            <BiFilterAlt className="w-5 h-5 text-white" />
                        </div>
                        <div>
                            <h3 className="text-lg font-bold text-gray-800">Lead Filters</h3>
                            <p className="text-sm text-gray-600">Filter and search through your leads efficiently</p>
                        </div>
                    </div>
                    <div className="flex items-center gap-2">
                        <div className="flex items-center gap-1.5 bg-green-100 border border-green-200 rounded-lg px-3 py-1.5">
                            <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                            <span className="text-sm font-medium text-green-700">
                                {[
                                    searchText && 'Search',
                                    statusFilter && 'Status',
                                    sourceFilter && 'Source',
                                    categoryFilter && 'Category',
                                    addedByFilter && 'Added By',
                                    assignedToFilter && 'Assigned To',
                                    dateRange.start && 'Date Range',
                                    stateFilter && 'State'
                                ].filter(Boolean).length} Active
                            </span>
                        </div>
                        {(searchText || statusFilter !== "" || sourceFilter !== "" ||
                            categoryFilter !== "" || dateRange.start || dateRange.end || addedByFilter !== "" || assignedToFilter !== "" || stateFilter !== "") && (
                            <button
                                onClick={resetFilters}
                                className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-red-600 bg-red-50 hover:bg-red-100 border border-red-200 rounded-lg transition-all duration-200 hover:shadow-md"
                            >
                                <BiRefresh size={16} />
                                Reset All
                            </button>
                        )}
                    </div>
                </div>

                {/* Primary Filters Row */}
                <div className="grid grid-cols-12 gap-4 mb-4">
                    <div className="col-span-12 md:col-span-6">
                        <label className="block text-sm font-medium text-gray-700 mb-2">🔍 Search Leads</label>
                        <SearchBar
                            placeholder="Search by name, phone, email..."
                            onSearch={handleSearch}
                            value={searchText}
                            className="w-full h-9"
                            compact
                        />
                    </div>
                    <div className="col-span-12 md:col-span-6">
                        <label className="block text-sm font-medium text-gray-700 mb-2">📅 Date Range</label>
                        <DateRangePicker
                            value={dateRange}
                            onChange={handleDateRangeChange}
                            className="w-full h-9"
                            compact
                        />
                    </div>
                </div>

                {/* Secondary Filters Grid */}
                <div className="bg-white rounded-lg border border-green-200 p-4">
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">🌍 State</label>
                            <Dropdown
                                placeholder='All States'
                                options={(statesOfIndia || []).map((state) => ({
                                    label: `🏛️ ${state}`,
                                    value: state
                                }))}
                                value={stateFilter}
                                needSearch={true}
                                onChange={handleStateFilterChange}
                                className="w-full h-9"
                                compact
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">📊 Status</label>
                            <Dropdown
                                options={statusOptions.map(option => ({
                                    ...option,
                                    label: `📋 ${option.label}`
                                }))}
                                value={statusFilter}
                                placeholder='All Status'
                                onChange={handleStatusFilterChange}
                                className="w-full h-9"
                                compact
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">📡 Source</label>
                            <Dropdown
                                options={sourceOptions.map(option => ({
                                    ...option,
                                    label: `🔗 ${option.label}`
                                }))}
                                value={sourceFilter}
                                placeholder='All Sources'
                                onChange={handleSourceFilterChange}
                                className="w-full h-9"
                                compact
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">📂 Category</label>
                            <Dropdown
                                options={categoryOptions.map(option => ({
                                    ...option,
                                    label: `📁 ${option.label}`
                                }))}
                                value={categoryFilter}
                                placeholder='All Categories'
                                onChange={handleCategoryFilterChange}
                                className="w-full h-9"
                                compact
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">👤 Added By</label>
                            <Dropdown
                                options={(staffUsers || []).map((staff) => ({
                                    label: `👤 ${staff.name}`,
                                    value: staff.id
                                }))}
                                value={addedByFilter}
                                placeholder='All Staff'
                                onChange={handleAddedByFilterChange}
                                className="w-full h-9"
                                compact
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">🎯 Assigned To</label>
                            <Dropdown
                                placeholder='All Staff'
                                options={(staffUsers || []).map((staff) => ({
                                    label: `🎯 ${staff.name}`,
                                    value: staff.id
                                }))}
                                value={assignedToFilter}
                                onChange={handleAssignedToFilterChange}
                                className="w-full h-9"
                                compact
                            />
                        </div>
                    </div>
                </div>

                {/* Results Footer */}
                <div className="flex items-center justify-between mt-4 pt-4 border-t border-green-200">
                    <div className="flex items-center gap-2 text-sm text-gray-600">
                        <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                        <span>Filters applied successfully</span>
                    </div>
                    <div className="text-sm text-gray-600">
                        <span className="font-medium">Results:</span> Showing filtered leads
                    </div>
                </div>
            </div>

            {/* Bulk Actions Section */}
            <div className="bg-white rounded-xl shadow-lg border border-gray-100 p-6">
                <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
                    <div className="flex items-center space-x-4">
                        <div className="flex items-center space-x-3">
                            <div
                                onClick={toggleSelectAll}
                                className={`relative inline-flex items-center h-7 rounded-full w-12 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary cursor-pointer ${isSelected ? 'bg-primary' : 'bg-gray-200'
                                    }`}
                            >
                                <span
                                    className={`inline-block w-5 h-5 transform transition-transform rounded-full bg-white shadow-md ${isSelected ? 'translate-x-6' : 'translate-x-1'
                                        }`}
                                />
                                <span className="sr-only">{isSelected ? "Deselect All" : "Select All"}</span>
                            </div>

                            <span className="text-sm font-semibold text-gray-700">
                                {isSelected ? "All Selected" : "Select All"}
                                <span className="ml-2 px-2 py-1 text-xs bg-blue-100 text-blue-800 rounded-full">
                                    {selectedLeads.length} selected
                                </span>
                            </span>
                        </div>
                    </div>

                    <div className="flex flex-col sm:flex-row gap-3">
                        <div className="min-w-48">
                            <Dropdown
                                name="user"
                                placeholder="Select Caller"
                                options={(staffUsers || []).map((staff) => ({
                                    label: staff.name,
                                    value: staff.id
                                }))}
                                value={selectedUser}
                                needSearch={true}
                                onChange={(selectedOption) => {
                                    setSelectedUser(selectedOption);
                                }}
                            />
                        </div>
                        <Button
                            onClick={handleAssignLeads}
                            disabled={!selectedLeads.length || !selectedUser}
                            className="px-6 py-2.5 bg-green-600 hover:bg-green-700 disabled:bg-gray-400 text-white rounded-lg shadow-sm hover:shadow-md transition-all duration-200 font-medium"
                        >
                            Assign {selectedLeads.length} Leads
                        </Button>
                    </div>
                </div>
            </div>

            {/* Data Table Section */}
            <div className="bg-white rounded-xl shadow-lg border border-gray-100 p-6">
                {loading ? (
                    <div className="flex justify-center py-16">
                        <CustomLoading size={100} className="my-2" />
                    </div>
                ) : (
                    <div className="space-y-4">
                        {data.count > 0 && (
                            <div className="flex justify-between items-center pb-4 border-b border-gray-200">
                                <h3 className="text-lg font-semibold text-gray-800">Lead Records</h3>
                                <Pagination
                                    currentPage={currentPage}
                                    totalPages={Math.ceil(data.count / pageSize)}
                                    pageSize={pageSize}
                                    totalEntries={data.count}
                                    onPageChange={handlePageChange}
                                    data={data}
                                    setData={setData}
                                />
                            </div>
                        )}

                        <Table
                            headers={headers}
                            rows={data?.results?.map(item => ({
                                checkbox: <div className="flex justify-center items-center">
                                    <div className={`
                                        relative
                                        w-6 h-6
                                        rounded-full
                                        flex justify-center items-center
                                        ${item.attended ? "bg-primary" : "bg-red-600"}
                                        ${selectedLeads.includes(item.id) ? "ring-2 ring-offset-2 ring-primary" : ""}
                                        transition-all duration-200
                                    `}>
                                        <input
                                            type="checkbox"
                                            checked={selectedLeads.includes(item.id)}
                                            onChange={() => toggleLeadSelection(item.id)}
                                            className={`
                                                absolute
                                                w-full h-full
                                                opacity-0
                                                cursor-pointer
                                            `}
                                        />
                                        {selectedLeads.includes(item.id) && (
                                            <svg
                                                className="w-4 h-4 text-white"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth={3}
                                                    d="M5 13l4 4L19 7"
                                                />
                                            </svg>
                                        )}
                                    </div>
                                </div>,
                                created_at: <div className="sticky left-[200px] bg-white z-10"><p className="hover:underline hover:text-primary cursor-pointer font-medium" onClick={() => openLeadDetails(item)}>{formatDateMonth(item.created_at)}</p></div>,
                                category: <p className="hover:underline hover:text-primary cursor-pointer font-medium" onClick={() => openLeadDetails(item)}>{item.category || "-"}</p>,
                                lead_source: <p className="hover:underline hover:text-primary cursor-pointer font-medium" onClick={() => openLeadDetails(item)}>{item.lead_source?.replace("_", " ") || "-"}</p>,
                                farmer_name: <p className="hover:underline hover:text-primary cursor-pointer font-medium" onClick={() => openLeadDetails(item)}>{item.name || "-"}</p>,
                                phone: <p className="hover:underline hover:text-primary cursor-pointer font-medium" onClick={() => openLeadDetails(item)}>{item.phone || "-"}</p>,
                                shop_product: (
                                    <div className="hover:underline hover:text-primary cursor-pointer" onClick={() => openLeadDetails(item)}>
                                        {/* Products Array */}
                                        {item.products && item.products.length > 0 ? (
                                            <div className="space-y-2">
                                                {item.products.map((product, index) => (
                                                    <div key={product.id || index} className="flex items-center gap-2 p-2 bg-gray-50 rounded border">
                                                        {product.product_image && (
                                                            <img
                                                                src={product.product_image}
                                                                alt={product.product_name}
                                                                className="w-8 h-8 rounded object-cover"
                                                                onError={(e) => {
                                                                    e.target.style.display = 'none';
                                                                }}
                                                            />
                                                        )}
                                                        <span className="text-sm font-medium text-gray-800 truncate max-w-48">
                                                            {product.product_name}
                                                        </span>
                                                    </div>
                                                ))}
                                            </div>
                                        ) : (
                                            /* Legacy product_name or shop_name */
                                            <span className="font-medium">
                                                {item.shop_name || item.product_name || "-"}
                                            </span>
                                        )}

                                        {/* Last Comment */}
                                        {item.last_comment && (
                                            <div className="mt-2 p-2 bg-yellow-50 rounded border border-yellow-200">
                                                <div className="text-xs font-semibold text-yellow-800 mb-1">Last Comment:</div>
                                                <p className="text-xs text-gray-700 leading-relaxed truncate max-w-48">
                                                    {item.last_comment}
                                                </p>
                                            </div>
                                        )}
                                    </div>
                                ),
                                address: <p className="hover:underline hover:text-primary cursor-pointer font-medium" onClick={() => openLeadDetails(item)}>{[item.address_line1, item.district, item.state, item.pincode].filter(Boolean).join(", ")}</p>,
                                added_by: <p className="hover:underline hover:text-primary cursor-pointer font-medium" onClick={() => openLeadDetails(item)}>{item.added_by_name || "-"}</p>,
                                assigned_to: <p className="hover:underline hover:text-primary cursor-pointer font-medium" onClick={() => openLeadDetails(item)}>{item.assigned_to_name || "—"}</p>,
                                no_of_followups: <p className="hover:underline hover:text-primary cursor-pointer font-medium" onClick={() => openLeadDetails(item)}>{item.follow_up || 0}</p>,
                                status: item.current_status ? <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-800 border border-gray-200">{item.current_status}</span> : "—",
                                note: (
                                    <div className="hover:underline hover:text-primary cursor-pointer" onClick={() => openLeadDetails(item)}>
                                        {item.note ? (
                                            <div className="p-2 bg-blue-50 rounded border border-blue-200">
                                                <div className="text-xs font-semibold text-blue-800 mb-1">Note:</div>
                                                <p className="text-xs text-gray-700 leading-relaxed truncate max-w-48">
                                                    {item.note}
                                                </p>
                                            </div>
                                        ) : (
                                            <span className="text-gray-400">-</span>
                                        )}
                                    </div>
                                ),
                            }))}
                        />
                    </div>
                )}
            </div>

            <ShowModal
                contentLabel="Lead Details"
                isOpen={modalIsOpen}
                modalWidth="70%"
                onRequestClose={closeModal}
                isSidebar
                componentToPass={
                    <TelecallingViewDetails
                        lead={selectedLead}
                        onClose={closeModal}
                        onStatusChange={(newStatus) => {
                            handleStatusChange(selectedLead.id, newStatus);
                            closeModal();
                        }}
                    />
                }
            />

            <ShowModal
                contentLabel="Add New Lead"
                isOpen={showAddLeadModal}
                modalWidth="60%"
                onRequestClose={() => { setShowAddLeadModal(false); setOpeningItem(null); }}
                componentToPass={
                    <AddLeadForm
                        onSubmit={handleAddLeadSubmit}
                        onCancel={() => { setShowAddLeadModal(false); setOpeningItem(null); }}
                        isSubmitting={isSubmitting}
                        initialValues={openindItem || {}}
                    />
                }
            />
        </div>
    );
}

export default Leads;
